const legacyStates = {
  'impact-add-ons-dev.myshopify.com': {
    schemaVersion: 1,
    groups: [{
      id: 'cmt6wv02t0001uyksm5ib9viq',
      name: 'test lee',
      enabled: true,
      status: 'PUBLISHED',
      assignments: ['gid://shopify/Product/8046390247489'],
      publishedProductGids: ['gid://shopify/Product/8046390247489'],
      publishedRevision: 6,
      shopifyMetaobjectId: 'gid://shopify/Metaobject/216877269057',
      lastPublishedAt: '2026-08-25T07:55:03.704Z',
      updatedAt: '2026-08-25T07:55:03.708Z',
      items: [
        legacyItem('cmt6x4xq20009uyksyqqmouc7', 'gid://shopify/Product/8046390476865', '', true, 'gid://shopify/Metaobject/216877170753'),
        legacyItem('cmt6x4xq2000buyksibtnu7jl', 'gid://shopify/Product/8046390313025', 'TEST SINGLE SKU', true, 'gid://shopify/Metaobject/216877203521'),
        legacyItem('cmt6xbj6w000fuyks8a3xp5v4', 'gid://shopify/Product/8046390280257', 'TEST SKUS', true, 'gid://shopify/Metaobject/216877236289'),
      ],
    }],
  },
  'redtiger-dash-cam.myshopify.com': {
    schemaVersion: 1,
    groups: [
      {
        id: 'cmt9vhv8u0009uy1wbf05ffvs',
        name: 'TEST F17E',
        enabled: true,
        status: 'PUBLISHED',
        assignments: ['gid://shopify/Product/8867145580779'],
        publishedProductGids: ['gid://shopify/Product/8867145580779'],
        publishedRevision: 4,
        shopifyMetaobjectId: 'gid://shopify/Metaobject/225389347051',
        lastPublishedAt: '2026-08-26T09:18:55.430Z',
        updatedAt: '2026-08-26T09:18:55.432Z',
        items: [
          legacyItem('cmt9vipmx000fuy1wor80uc3u', 'gid://shopify/Product/8021645328619', 'SD Card', true, 'gid://shopify/Metaobject/225389248747'),
          legacyItem('cmt9vlj4g000huy1wo5rfav7b', 'gid://shopify/Product/9380046831851', 'Circular Polarizing Lens', true, 'gid://shopify/Metaobject/225389281515'),
          legacyItem('cmt9vlj4g000juy1wqv1wss4x', 'gid://shopify/Product/8960165839083', 'Replacement Cables', true, 'gid://shopify/Metaobject/225389314283'),
          legacyItem('cmt9vsi0c000xuy1wgpw2d4x2', 'gid://shopify/Product/8036544086251', '3M Adhesive', true, 'gid://shopify/Metaobject/225390002411'),
        ],
      },
      {
        id: 'cmt9w6xj80013uy1w50z3kj1n',
        name: 'TEST F7NP',
        enabled: true,
        status: 'DRAFT',
        assignments: ['gid://shopify/Product/7626584457451'],
        publishedProductGids: ['gid://shopify/Product/7626584457451'],
        publishedRevision: 4,
        shopifyMetaobjectId: 'gid://shopify/Metaobject/225390985451',
        lastPublishedAt: '2026-08-26T09:36:06.648Z',
        updatedAt: '2026-08-26T09:37:22.276Z',
        items: [
          legacyItem('cmt9w7eq50019uy1wi33qydzc', 'gid://shopify/Product/8021645328619', 'SD Card', true, 'gid://shopify/Metaobject/225390887147'),
          legacyItem('cmt9w7uoz001buy1wfgjt0zar', 'gid://shopify/Product/8018810208491', 'Circular Polarizing Lens', true, 'gid://shopify/Metaobject/225390919915'),
          legacyItem('cmt9w8b2s001duy1wqx6a0z7h', 'gid://shopify/Product/8022664511723', 'Replacement Cables', false, null),
          legacyItem('cmt9w8x7m001fuy1w4ejxepyl', 'gid://shopify/Product/8752577380587', 'Card Reader', true, 'gid://shopify/Metaobject/225390952683'),
          legacyItem('cmt9wdjmv001luy1w4plsa7sh', 'gid://shopify/Product/8828970041579', '', true, 'gid://shopify/Metaobject/225392689387'),
          legacyItem('cmt9wdjmv001nuy1wr79ibxvk', 'gid://shopify/Product/9358186414315', '', true, 'gid://shopify/Metaobject/225392722155'),
          legacyItem('cmt9wh65h0021uy1wt7zflj0t', 'gid://shopify/Product/8099464872171', '', true, null),
          legacyItem('cmt9wh65h0023uy1w40w0yj2d', 'gid://shopify/Product/9062045548779', '', true, null),
        ],
      },
    ],
  },
};

export function legacyStateForShop(shopDomain) {
  const state = legacyStates[shopDomain];
  return state ? JSON.parse(JSON.stringify(state)) : null;
}

function legacyItem(id, productGid, customTitle, enabled, shopifyMetaobjectId) {
  return {
    id,
    productGid,
    variantMode: 'auto',
    fixedVariantGid: '',
    defaultVariantGid: '',
    customTitle,
    shortDescription: '',
    defaultSelected: false,
    quantityMode: 'one',
    enabled,
    shopifyMetaobjectId,
  };
}
